import { useTheme } from '@mui/material';
import { PlayCircle, Followers } from '@sparemin/blockhead';
import DetailCard from 'components/DetailCard';
import React from 'react';
import { usePodcastMetrics } from '../state';
import RevenueStat from './RevenueStat';
import Stat from './Stat';

type SocialStatsSummaryProps = {};

const SocialStatsSummary: React.FC<SocialStatsSummaryProps> = () => {
  const width = '33%';
  const theme = useTheme();
  const { data, isLoading } = usePodcastMetrics();

  const { playCount, followCount, revenue } = data ?? {};

  return (
    <DetailCard>
      <Stat
        loading={isLoading}
        icon={
          <PlayCircle
            color={theme.palette.supporting1.main}
            height="16px"
            width="16px"
          />
        }
        numberOf={playCount ?? 0}
        statsType="plays"
        width={width}
      />

      <Stat
        loading={isLoading}
        icon={
          <Followers
            height="16px"
            width="20px"
            color={theme.palette.supporting3.main}
          />
        }
        numberOf={followCount ?? 0}
        statsType="followers"
        width={width}
      />

      <RevenueStat loading={isLoading} revenue={revenue} width={width} />
    </DetailCard>
  );
};

export default SocialStatsSummary;
